import { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/link'
import { helloBabyPostPath } from 'lib/urls'
import css from './hero-post.scss'

class HeroPost extends Component {
  static defaultProps = {
    navigateWithRouter: true,
  }

  render() {
    let { post, navigateWithRouter } = { ...this.props }
    const navigationProp = {
      [!navigateWithRouter ? 'url' : 'to']: helloBabyPostPath(
        post && post.slug
      ),
    }
    return (
      <Link className="text-body" {...navigationProp}>
        <div key={4123} className={classNames(css.heroPostContainer)}>
          <div
            style={{ backgroundImage: 'url(' + post.featuredImage.url + ')' }}
            className={classNames(
              css.featuredImage,
              'hover-overlay hover-lighten'
            )}
          ></div>
          <div className={classNames(css.postInfo, 'flex-vertical-center')}>
            <div>
              <div className={`h3 ${css.postTitle}`}>{post.title}</div>
              <p className={classNames(css.textSerifGuides, 'mbn')}>
                {post.teaser}
              </p>
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

HeroPost.propTypes = {
  post: PropTypes.object.isRequired,
}

export default HeroPost
